/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, NgZone, OnInit} from '@angular/core';
import template from './tier-edit-page.component.html';
import {AppEventBusService} from '../../common/events/app-event-bus.service';

import {AdminResourceEditPageBase} from '../../common/controller/admin-resource-edit-page-base';
import {initTierModel, isTierEnabled} from './tier-commons';
import {NetworkResource} from '../../../components/api/resources/resource/network.resource';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {UserProfileSaverService} from '../../../components/session/user-profile-saver.service';

@Component({
  standalone: false,
  selector: 'adn-tier-edit-page',
  template
})
export class TierEditPageComponent extends AdminResourceEditPageBase implements OnInit {
  tierEnabled = false;

  constructor(
    eventBus: AppEventBusService,
    @Inject(UserProfileSaverService) UserProfileSaver: any,
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    @Inject(NetworkResource) private Network: any,
    ngZone: NgZone
  ) {
    super(eventBus, UserProfileSaver, LocalNetworkProfile, ngZone);
  }

  ngOnInit(): void {
    this.loadTierEnabled();
  }

  protected afterInitEditingModel(): void {
    initTierModel(this.editingModel);
    this.loadTierEnabled();
  }

  private loadTierEnabled(): void {
    if (!this.editingModel?.id) {
      this.tierEnabled = false;
      return;
    }
    this.Network.get({id: this.LocalNetworkProfile.getNetworkId()}).$promise.then((network: any) => {
      this.tierEnabled = isTierEnabled(this.editingModel.id, network);
    });
  }
}
